<script setup>
import { useAuditText } from './audit-text.js'
import { sourceRows } from './run-observer.js'

defineProps({
  // 带 evidence_ids 的记录（人物记录、导演建议、事件）。
  record: { type: Object, required: true },
  sources: { type: Map, required: true },
})

const { tr, sourceLabel } = useAuditText()
</script>

<template>
  <ul class="au-evidence-list" :aria-label="tr('sources.evidenceLabel')">
    <li v-for="source in sourceRows(sources, record)" :key="source.evidence_id" :title="source.evidence_id">
      <span class="au-muted">{{ sourceLabel(source) }}</span>
      <p v-if="source.text" class="au-body">{{ source.text }}</p>
      <p v-else class="au-empty" :title="tr('sources.missing')">{{ tr('empty') }}</p>
    </li>
  </ul>
</template>
